import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Coins, Menu, X } from "lucide-react";
import { useMe } from "@/context/MeContext";

const links = [
  { to: "/radio", label: "Radio" },
  { to: "/programas", label: "Programas" },
  { to: "/medios", label: "Medios" },
  { to: "/creditos", label: "Créditos" },
];

const navCls = ({ isActive }) => `text-sm font-medium transition-colors ${isActive ? "text-white" : "text-slate-400 hover:text-white"}`;

export const Header = () => {
  const { me } = useMe();
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 z-40 w-full border-b border-white/5 bg-[#0A0A0E]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-4 md:px-8">
        <Link to="/" data-testid="header-logo" className="shrink-0 font-heading text-base font-extrabold tracking-tight text-white sm:text-lg">
          RARA<span className="text-[#FF4500]">·</span>PERLA
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => <NavLink key={l.to} to={l.to} data-testid={`nav-${l.to.slice(1)}`} className={navCls}>{l.label}</NavLink>)}
          <Show when="signed-in"><NavLink to="/panel" data-testid="nav-panel" className={navCls}>Mi panel</NavLink></Show>
        </nav>
        <div className="flex items-center gap-3">
          <Show when="signed-in">
            {me && me.role !== "curator" && (
              <Link to="/creditos" data-testid="header-credits-balance" className="hidden items-center gap-1.5 rounded-full border border-white/10 px-3 py-1 font-mono text-xs text-amber-400 sm:flex">
                <Coins className="h-3.5 w-3.5" />{me.credits} créditos
              </Link>
            )}
            <UserButton />
          </Show>
          <Show when="signed-out">
            <Link to="/sign-in" data-testid="header-sign-in-btn" className="hidden text-sm text-slate-300 hover:text-white sm:inline">Ingresar</Link>
            <Link to="/sign-up" data-testid="header-sign-up-btn" className="whitespace-nowrap rounded-full bg-[#FF4500] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-[#ff5a1f] sm:px-4 sm:py-2 sm:text-sm">Crear cuenta</Link>
          </Show>
          <button data-testid="header-mobile-menu-btn" className="text-slate-300 md:hidden" onClick={() => setOpen(!open)} aria-label="Menú">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="flex flex-col gap-4 border-t border-white/5 bg-[#0A0A0E] px-4 py-4 md:hidden" onClick={() => setOpen(false)}>
          {links.map((l) => <NavLink key={l.to} to={l.to} data-testid={`mobile-nav-${l.to.slice(1)}`} className={navCls}>{l.label}</NavLink>)}
          <Show when="signed-out"><NavLink to="/sign-in" data-testid="mobile-nav-sign-in" className={navCls}>Ingresar</NavLink></Show>
          <Show when="signed-in"><NavLink to="/panel" data-testid="mobile-nav-panel" className={navCls}>Mi panel</NavLink></Show>
        </nav>
      )}
    </header>
  );
};
